export default "__VITE_ASSET__1jvqd$if__"